export const EMPTY_STRING = '';
export const EMPTY_CONTENT = '<p></p>';
